module.exports = __webpack_public_path__ + "544e2fd8450a238d78a0b33d7981f3e3.svg";